import { AuthProvider } from "./providers/AuthProvider";

function App({ children }) {
  return (
    <AuthProvider>
      <div className="App">
        {children}
      </div>
    </AuthProvider>
  )
}


export default App;